"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var createGuidedSupportSession = function (subdomain, payload) {
    return (0, service_1.getService)()
        .post("/guided_support_sessions/subdomain/".concat(subdomain), payload, {
        withCredentials: true,
    })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = createGuidedSupportSession;
